import { combineReducers } from 'redux';
import employeeReducer from './employee/employeeReducer';
import interviewReducer from './interview/interviewReducer';
export default combineReducers({
 employee: employeeReducer,
 interview: interviewReducer
});